import React from 'react';
import { useSelector } from 'react-redux';
import { selectTier1PieChartData } from '../../../../../../slices/teamStatsSlice';
import DistributionPieCard from './DistributionPieCard';

const Tier1 = () => {
  const pieChartData = useSelector(selectTier1PieChartData)
  
  return (
    <DistributionPieCard title="Tier 1 Investigations" pieChartData={pieChartData} />
  )
}

export default Tier1;
